import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";
import { clearAppData, removeCookie, storeData } from "utils/storage";


export interface registrationSaliha {
  Id?: number;
  NoDaftar?: string;
  ChannelId?: string;
  Kbli?: string;
  Nib?: string;
  JenisProduk?: string;
  MerekDagang?: string;
  AreaPemasaran?:string;
  Status?: string;
  Keterangan?: string;
  SumberData?: string;
  NoSertifikatHalal?: string;
  FileSertifikatHalal?: string;
  TglSertifikatHalal?: string;
}

export interface registrationSalihaParams {
  pagination: {
    size: number
    perPage: number,
  };
  filter: registrationSaliha;
  sort: registrationSaliha;
}

export interface getsRegistrationSalihaResponse {
  GETS_REGISTRATIONSALIHA: {
    status: number,
    totalData: number,
    totalPage: number,
    data: registrationSaliha[]
  };
}

export interface RegisterInterface {
  name: string;
  email: string;
  password: string;
}

export const getsRegistrationSaliha = createAsyncThunk(
  "getsRegistrationSaliha",
  async (params: registrationSalihaParams, thunkAPI) => {
    
    const config = {
      method: "get",
      url: "registration/selfdeclare/pra-submission-saliha",
      params,
    };

    return api(config).then(
      (res: any) => {
        return res.data;
      },
      (err: any) => {
        return thunkAPI.rejectWithValue(err.response.data.message);
      }
    );
  }
);

export const updateRegistrationSaliha = createAsyncThunk(
  "updateRegistrationSaliha",
  async (data: registrationSaliha, thunkAPI) => {
    
    const config = {
      method: "put",
      url: "reg-selfdeclare/submission-saliha/" + data.Id,
      data: {
        UPDATE_REGISTRATIONSALIHA: data
      }
    };

    return api(config).then(
      (res: any) => {
        return res.data;
      },
      (err: any) => {
        return thunkAPI.rejectWithValue(err.response.data.message);
      }
    );
  }
);


const SalihaSubmission = createSlice({
  name: "SalihaSubmission",
  initialState: {
    data: { 
      GETS_REGISTRATIONSALIHA: {
        status: 0,
        totalData: 0,
        totalPage: 0,
        data: [{
          Id: 0,
          Kbli: "",
          Nib: ""
        }]
      }
    } as getsRegistrationSalihaResponse,
    isUpdateSuccess: false,
    isUpdateFetching: false,
    
    isFetching: false,
    isSuccess: false,
    
    isError: false,
    errorMessage: "" as string,
  },
  reducers: {
    clearState: (state, action) => {
      state.isFetching = false;
      state.isSuccess = false;

      state.isUpdateFetching = false;
      state.isUpdateSuccess = false;

      state.isError = false;
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getsRegistrationSaliha.fulfilled, (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.data = payload;
      return state;
    });
    builder.addCase(getsRegistrationSaliha.rejected, (state, payload: any) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload.payload;
    });
    builder.addCase(getsRegistrationSaliha.pending, (state, action) => {
      state.isFetching = true;
    });
   
    builder.addCase(updateRegistrationSaliha.fulfilled, (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.data = payload;
      return state;
    });
    builder.addCase(updateRegistrationSaliha.rejected, (state, payload: any) => {
      state.isUpdateFetching = false;
      state.isError = true;
      state.errorMessage = payload.payload;
    });
    builder.addCase(updateRegistrationSaliha.pending, (state, action) => {
      state.isUpdateFetching = true;
    });
  },
});

export const { clearState } = SalihaSubmission.actions;
export default SalihaSubmission.reducer;
